import { createAppRequest } from '@/services/request';
import type { ApiRequestOptions } from './types/common';
import type {
  CreateFamsManagerManagementPayload,
  FamsManagerManagementItem,
  FamsManagerManagementListParams,
  FamsManagerManagementListResponse,
  UpdateFamsManagerManagementPayload,
} from './types/manager-management';

const request = createAppRequest();

export async function getFamsManagerManagementList(
  params?: FamsManagerManagementListParams,
  options?: ApiRequestOptions,
) {
  return request<FamsManagerManagementListResponse>('/bff/fams/managers/list', {
    method: 'GET',
    params,
    ...(options || {}),
  });
}

export async function getFamsManagerManagementDetail(
  id: number,
  options?: ApiRequestOptions,
) {
  return request<FamsManagerManagementItem>(`/bff/fams/managers/${id}`, {
    method: 'GET',
    ...(options || {}),
  });
}

export async function createFamsManagerManagement(
  payload: CreateFamsManagerManagementPayload,
  options?: ApiRequestOptions,
) {
  return request<FamsManagerManagementItem>('/bff/fams/managers', {
    method: 'POST',
    data: payload,
    ...(options || {}),
  });
}

export async function updateFamsManagerManagement(
  id: number,
  payload: UpdateFamsManagerManagementPayload,
  options?: ApiRequestOptions,
) {
  return request<FamsManagerManagementItem>(`/bff/fams/managers/${id}`, {
    method: 'PUT',
    data: payload,
    ...(options || {}),
  });
}

export async function deleteFamsManagerManagement(
  id: number,
  options?: ApiRequestOptions,
) {
  return request<{ success: boolean; id: number }>(`/bff/fams/managers/${id}/delete`, {
    method: 'PATCH',
    ...(options || {}),
  });
}
